import { render, staticRenderFns } from "./TypesUpdateModal.vue?vue&type=template&id=08d794d2&"
import script from "./TypesUpdateModal.vue?vue&type=script&lang=js&"
export * from "./TypesUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports